"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeIsEqual = void 0;
const react_final_form_1 = require("react-final-form");
const react_1 = __importDefault(require("react"));
const TimePicker_1 = __importDefault(require("../../components/TimePicker/TimePicker"));
const moment_1 = __importDefault(require("moment"));
// Helps check if field is dirty by ONLY comparing the time
const timeIsEqual = (maybeDatetime1, maybeDatetime2) => {
    if (maybeDatetime1 === maybeDatetime2) {
        return true;
    }
    return (0, moment_1.default)(maybeDatetime1).format('HH:mm:ss') === (0, moment_1.default)(maybeDatetime2).format('HH:mm:ss');
};
exports.timeIsEqual = timeIsEqual;
const TimeField = ({ name, label, timezone, validate, date, ...rest }) => (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate, isEqual: exports.timeIsEqual }, ({ input, meta, ...renderProps }) => (
// @ts-ignore
react_1.default.createElement(TimePicker_1.default, { fullWidth: true, timezone: timezone, date: date, label: label, meta: meta, ...input, helperText: meta.touched && meta.error, error: meta.touched && meta.error, ...renderProps, ...rest }))));
exports.default = TimeField;
